import { Stack, Title, rem } from '@mantine/core';
import { useNavbarExpanded } from '../hooks';

export const NavigationSection = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title?: string;
}) => {
  const { isDesktopExpanded } = useNavbarExpanded();

  return (
    <Stack gap={rem(5)} my={rem(3)}>
      {title && isDesktopExpanded && (
        <Title order={5} c={'white'} opacity={0.6} fw={400} ml={8}>
          {title}
        </Title>
      )}
      {children}
    </Stack>
  );
};
